export const APP_USER_AGENT = 'BGMer/1.0 (https://github.com/bangumi/api)';
export const BGM_AUTH_HEADER = 'x-bgmer-bangumi-auth';
export const DEFAULT_REQUEST_TIMEOUT_MS = 10_000;
export const HOUR_MS = 60 * 60 * 1_000;
export const DAY_MS = 24 * HOUR_MS;
